const zipRegex = new RegExp("^[0-9]{5}(?:-[0-9]{4})?$");
const specialChars = new RegExp(/[`!@#$%^&*()+=\\[\]{};':"\\|,.<>\\/?~]/);
const toNumber = num => parseFloat(num);

//  createValidator takes in many functions and spreads them out as test as an array.
//  It will run throw every single function and return true or false according.
//  It will only return true if every single functions are passed.
const createValidator = (...tests) => {
    return (item1, item2, item3, item4) => {
        return tests.every(test => test(item1, item2, item3, item4) === true);
    };
};

//  DESC: isStringLongEnough takes in a string as String and a length as Number.
//  DESC: It where return truthy and falsy.
const isStringLongEnough = (min, string) => string.length > toNumber(min);
const isStringShortEnough = (max, string) => string.length <= toNumber(max);
const isStringInRange = (min, max, string) =>
    toNumber(min) <= string.length && string.length <= toNumber(max);

const isNumberInRange = (min, max, num) =>
    toNumber(min) <= toNumber(num) && toNumber(num) <= toNumber(max);

const isValidZipcode = zip => zipRegex.test(zip);
const isNumberNegative = number => (Math.sign(number) === -1);
const isNumberLessThan = (max, num) => toNumber(num) <= toNumber(max);
const isNumberMoreThan = (min, num) => toNumber(min) <= toNumber(num);

const isUndefined = value => value === "undefined" || value === undefined;
const isIncludeSpecialChar = value => specialChars.test(value);
export const StringValidator = {
    isStringLongEnough: createValidator(isStringLongEnough),
    isStringShortEnough: createValidator(isStringShortEnough),
    isStringInRange: createValidator(isStringInRange)
};
export const NumberValidator = {
    isNumberInRange: createValidator(isNumberInRange),
    isNumberShortEnough: createValidator(isStringShortEnough),
    isNumberLessThan: createValidator(isNumberLessThan),
    isNumberMoreThan: createValidator(isNumberMoreThan),
    isNumberNegative: createValidator(isNumberNegative),
    isValidZipcode: createValidator(isValidZipcode)
};

export const TypeValidator = {
    isUndefined: createValidator(isUndefined),
    isIncludeSpecialChar: createValidator(isIncludeSpecialChar)
};